import React, { FC, ReactNode, CSSProperties } from "react";
import { zIndex } from "../../consts/theme";
import { useStyles } from "./BackdropStyles";
import { useViewportConfig } from "@narvar/nth-kit-returns-headless";

type Props = {
  s?: CSSProperties;
  children: ReactNode;
};

const Backdrop: FC<Props> = ({ s, children }) => {
  const viewportConfig = useViewportConfig();

  const styles = useStyles();

  return (
    <div
      className={styles.backdropContainer}
      {...viewportConfig.anchor}
      style={{
        zIndex: zIndex.Modal,
        top: viewportConfig.anchor?.offsetTop ?? 0,
        bottom: viewportConfig.anchor?.offsetBottom ?? 0,
        left: viewportConfig.anchor?.offsetLeft ?? 0,
        right: viewportConfig.anchor?.offsetRight ?? 0,
        ...s,
      }}>
      {children}
    </div>
  );
};

export default Backdrop;
